/**
 *  @author: Maximilian Gertz
 *  @email: mgertz@nanocosmos.net
 *  @organization: Nanocosmos GmbH
 *  @version: (introduced in analytics-front) 2.26.0
 */

// React Imports
import React from 'react';
import { PropTypes } from 'prop-types';

// Custom Imports
import { ALERT_TYPE } from '../constants';
import StrPerformanceWidget from './StrPerformanceWidget';
import MaxFrameDelayWidget from './MaxFrameDelayWidget';
import ContinuousRestartsWidget from './ContinuousRestartsWidget';
import DuplicatedIngestWidget from './DuplicatedIngestWidget';
import InactiveIngestWidget from './InactiveIngestWidget';

export function AlertWidgets({ selectedAlert, streamName, height }) {
   return (
      <>
         {selectedAlert.type === ALERT_TYPE.STREAM_TIME_RATIO && (
            <StrPerformanceWidget selectedAlert={selectedAlert} streamName={streamName} height={height} />
         )}
         {selectedAlert.type === ALERT_TYPE.MAX_FRAME_DELAY && (
            <MaxFrameDelayWidget selectedAlert={selectedAlert} streamName={streamName} height={height} />
         )}
         {selectedAlert.type === ALERT_TYPE.CONTINUOUS_RESTARTS && (
            <ContinuousRestartsWidget streamName={streamName} selectedAlert={selectedAlert} height={height} />
         )}
         {selectedAlert.type === ALERT_TYPE.DUPLICATED_INGEST && (
            <DuplicatedIngestWidget selectedAlert={selectedAlert} height={height} />
         )}
         {selectedAlert.type === ALERT_TYPE.INACTIVE_INGEST && (
            <InactiveIngestWidget selectedAlert={selectedAlert} streamName={streamName} height={height} />
         )}
      </>
   );
}

AlertWidgets.propTypes = {
   selectedAlert: PropTypes.object,
   streamName: PropTypes.string,
   height: PropTypes.number,
};

AlertWidgets.defaultProps = {
   height: 300,
};

export default AlertWidgets;
